/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-restricted-globals */
/* eslint-disable compat/compat */
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Icon,
  IconButton,
  Popover,
  Typography,
} from '@worthy-npm/worthy-common-ui-components';
import { AnimatePresence } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import _ from 'lodash';
import {
  ActionBtnWrap,
  ActionButton,
  ArrowR,
  BackButtonWrapper,
  BtnWrapper,
  ChatArea,
  ChatBoxContainer,
  ClearButton,
  ClearConversation,
  ContinueBtn,
  Header,
  InitialInputContainer,
  InputContainerChat,
  MessageBubble,
  MessageRow,
  NewConversationPopup,
  NextButton,
  OuterContainer,
  OutlinedStarIcon,
  SendButton,
  StarInCircleIcon,
  StyledTextField,
  TitleWrap,
} from '../../styles/aiSubmit.styles';
import WorthyAPI from '../../services/worthyAPI';
import { useAppDispatch, useAppSelector, useMobileVersion } from '../../app/hooks';
import {
  getConversationMessages,
  getConversationSubmit,
  getConversationWaiting,
  getConversationId,
  selectSubmissionId,
  clearConversation,
  clearConversationStorage,
  setConversationWaiting,
  interruptConversationSubmit,
  Message,
  getResponseStarted,
  setConversationResponseStatus,
  setResponseStarted,
} from '../../slices/submitSlice';
import { subscribeToSocketEvents } from '../../services/socket';
import { StepProps } from './common';
import GA from '../../data/GA';
import { CookieStore } from '../../services/cookieStore';
import StepTitle from '../stepTitle';

function NextButtonComponent({ onClick }: { onClick: () => void }) {
  const scrollToBtnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      scrollToBtnRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <NextButton
      ref={scrollToBtnRef}
      disableElevation
      fullWidth
      type="submit"
      data-automation="ai-submit-next"
      variant="contained"
      size="large"
      color="highlight"
      onClick={onClick}
    >
      Next
    </NextButton>
  );
}

const MessageItem = React.memo(({ msg }: { msg: Message }) => {
  if (msg.role !== 'user') {
    return (
      <MessageRow role={msg.role} id="message-row">
        <MessageBubble assistant loading={false}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', whiteSpaceCollapse: 'collapse' }}>
            <StarInCircleIcon id="star" sx={{ mr: 1, mt: '12px' }} />
            <Typography variant="body1" component="span">
              <ReactMarkdown>{msg.content}</ReactMarkdown>
            </Typography>
          </Box>
        </MessageBubble>
      </MessageRow>
    );
  }
  return (
    <MessageRow role={msg.role} id="message-row">
      <MessageBubble assistant={false} loading={false}>
        <Typography variant="body1">{msg.content}</Typography>
      </MessageBubble>
    </MessageRow>
  );
});
MessageItem.displayName = 'MessageItem';

export default function Chat({ next, prev, active }: StepProps) {
  const dispatch = useAppDispatch();
  const submissionId = useAppSelector(selectSubmissionId);
  const simulationHappened = useRef(false);
  const uvid = CookieStore.getUvid() || CookieStore.getGaId();
  const socketMessages = useAppSelector(getConversationMessages);
  const conversationId = useAppSelector(getConversationId);
  const waiting = useAppSelector(getConversationWaiting);
  const submit = useAppSelector(getConversationSubmit);
  const isResponseStarted = useAppSelector(getResponseStarted);
  const isMobile = useMobileVersion();
  const [messages, setMessages] = useState<Message[]>(socketMessages);

  const [userInput, setUserInput] = useState('');
  const [chatStarted, setChatStarted] = useState(socketMessages.length > 0);
  const dummyRef = useRef<HTMLDivElement>(null);
  const chatInputRef = useRef<HTMLInputElement>(null);
  const [focusCalled, setFocusCalled] = useState(false);
  const [initialMsg, setInitialMsg] = useState<Message | null>(null);

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!active) return;
    GA.aiChatView();
  }, [active]);

  useEffect(() => {
    if (socketMessages.length > 0 && socketMessages[0].role !== 'user' && initialMsg) {
      setMessages([initialMsg, ...socketMessages]);
    } else {
      setMessages(socketMessages);
    }
  }, [socketMessages, initialMsg]);

  useEffect(() => {
    if (!submissionId) return;

    const urlParams = new URLSearchParams(window.location.search);
    const encodedMsg = urlParams.get('msg');

    if (simulationHappened.current || !encodedMsg) return;
    simulationHappened.current = true;

    const base64Msg = decodeURIComponent(encodedMsg);
    const decodedMsg = decodeURIComponent(escape(atob(base64Msg)));
    setInitialMsg({ role: 'user', content: decodedMsg } as Message);
    setMessages((rest) => [...rest, { role: 'user', content: decodedMsg } as Message]);
    setChatStarted(true);
    dispatch(setConversationWaiting({ waiting: true }));

    const simulateChatProcess = async (msg: string) => {
      try {
        await WorthyAPI.createNewMessage(msg, submissionId, conversationId);
        dispatch(setResponseStarted({ responseStarted: true }));
      } catch (error) {
        console.error('Error simulating chat process:', error);
      } finally {
        urlParams.delete('msg');
        const newQuery = urlParams.toString();
        window.history.replaceState(null, '', newQuery ? `?${newQuery}` : location.pathname);
        dispatch(setConversationWaiting({ waiting: false }));
      }
    };
    simulateChatProcess(decodedMsg);
  }, [submissionId, dispatch]);

  useEffect(() => {
    if (!uvid) return;
    subscribeToSocketEvents(uvid, dispatch);
  }, [uvid]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dummyRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, 100);

    return () => clearTimeout(timer);
  }, [socketMessages, submit, waiting]);

  useEffect(() => {
    if (chatStarted) {
      GA.onSecondChatScreenLoad();
    }
  }, [chatStarted]);

  // to prevent multiple sending message requests before dispatcher update waiting flag
  let localWaiting = false;
  const handleSend = async () => {
    if (!userInput.trim() || waiting || localWaiting) return;
    localWaiting = true;
    if (!chatStarted) {
      GA.onContinueChatClick();
      setChatStarted(true);
    }
    if (submit) dispatch(interruptConversationSubmit());
    dispatch(setConversationWaiting({ waiting: true }));
    const userMsg = _.cloneDeep(userInput);
    setMessages((rest) => [...rest, { role: 'user', content: userMsg } as Message]);
    setUserInput('');
    const respond = await WorthyAPI.createNewMessage(userMsg, submissionId, conversationId);

    dispatch(
      setConversationResponseStatus({
        responseStarted: true,
        conversationId: respond.conversationId,
      }),
    );

    if (!isMobile) {
      setTimeout(() => {
        chatInputRef.current?.focus();
      }, 1000);
    }
  };

  const handleKeyDown = async (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      await handleSend();
    }
  };

  const handleFocus = () => {
    if (!focusCalled) {
      GA.aiFocus();
      setFocusCalled(true);
    }
  };

  const handleNext = () => {
    GA.chatNext();
    dispatch(clearConversationStorage());
    next({} as any);
  };

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <OuterContainer id="outer">
      <AnimatePresence mode="wait">
        {!chatStarted ? (
          <>
            <Header
              key="header"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
            >
              <Typography variant={isMobile ? 'h2Mobile' : 'h2'}>
                <BackButtonWrapper
                  disableRipple
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    prev(e);
                  }}
                >
                  <Icon.ExpandMoreShineIcon />
                </BackButtonWrapper>
                Tell us about your item!
              </Typography>
            </Header>
            <InitialInputContainer
              key="initialInput"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
            >
              <StyledTextField
                autoFocus
                initInput={true}
                multiline
                rows={6}
                value={userInput}
                placeholder="To begin selling, enter a short description of your item."
                onFocus={handleFocus}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </InitialInputContainer>
            <BtnWrapper
              key="btn"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
            >
              <ContinueBtn
                disableElevation
                type="submit"
                onClick={handleSend}
                disabled={!userInput.length}
                variant="contained"
                size="large"
                color="highlight"
              >
                Continue
              </ContinueBtn>
            </BtnWrapper>
          </>
        ) : (
          <ChatBoxContainer
            key="chatBox"
            id="chatBox"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
          >
            <ClearButton id="clear-button" onClick={handleOpen}>
              <ClearConversation style={{ width: '18px', height: '18px' }} />
            </ClearButton>
            <Popover
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={open}
              onClose={handleClose}
              anchorEl={anchorEl}
            >
              <NewConversationPopup>
                <TitleWrap>
                  <Typography
                    flex="1 1 auto"
                    textAlign="center"
                    marginLeft="30px"
                    variant="body1"
                    fontWeight="700"
                  >
                    Start a new conversation?
                  </Typography>

                  <IconButton
                    onClick={handleClose}
                    variant="default"
                    size="small"
                    color="secondary"
                    style={{ width: '20px', height: '20px' }}
                  >
                    <Icon.CloseIcon
                      data-automation="close"
                      style={{ width: '20px', height: '20px' }}
                    />
                  </IconButton>
                </TitleWrap>
                <Typography variant="body1">
                  Starting a new conversion will delete the current one, Are you sure?
                </Typography>

                <ActionBtnWrap>
                  <ActionButton
                    variant="outlined"
                    onClick={handleClose}
                    fullWidth
                    disableElevation
                    deleteAction={false}
                  >
                    Cancel
                  </ActionButton>
                  <ActionButton
                    deleteAction
                    id="delete-conversation"
                    fullWidth
                    disableElevation
                    onClick={() => {
                      handleClose();
                      dispatch(clearConversation());
                      setChatStarted(false);
                      setUserInput('');
                    }}
                    variant="contained"
                    color="error"
                  >
                    Delete
                  </ActionButton>
                </ActionBtnWrap>
              </NewConversationPopup>
            </Popover>
            <ChatArea id="chat-area">
              {messages.map((msg, idx) => (
                <MessageItem key={idx} msg={msg} />
              ))}
              {isResponseStarted && !submit && (
                <MessageRow role="assistant">
                  <MessageBubble assistant loading={isResponseStarted}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                      <StarInCircleIcon id="star" sx={{ mr: 1, mt: 2 }} />
                      <OutlinedStarIcon id="outlined-star" />
                    </Box>
                  </MessageBubble>
                </MessageRow>
              )}
              {submit && !waiting && <NextButtonComponent onClick={handleNext} />}
              <div ref={dummyRef} />
            </ChatArea>
            <InputContainerChat>
              <StyledTextField
                inputRef={chatInputRef}
                initInput={false}
                multiline
                minRows={1}
                maxRows={6}
                value={userInput}
                placeholder="Tell me about your item:"
                inputProps={{ style: { paddingLeft: '10px' } }}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <SendButton onClick={handleSend}>
                <ArrowR color="inherit" />
              </SendButton>
            </InputContainerChat>
          </ChatBoxContainer>
        )}
      </AnimatePresence>
    </OuterContainer>
  );
}
